import React from 'react';
import Nav from '../../components/Nav';
import Footer from '../../components/Footer';
import { Target, Award, Users, BookOpen, ShieldCheck } from 'lucide-react';

const AboutUs = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col pt-14 sm:pt-16">
      <Nav />
      <main className="flex-1 max-w-5xl mx-auto px-3 sm:px-6 lg:px-8 py-3 sm:py-5 w-full space-y-3.5 sm:space-y-5">
        {/* Header */}
        <div className="bg-gradient-to-r from-emerald-800 via-teal-900 to-emerald-900 rounded-xl sm:rounded-2xl p-3.5 sm:py-4 sm:px-6 md:py-4 md:px-6 text-white text-center space-y-1.5 shadow-xs">
          <span className="bg-emerald-500/30 text-emerald-300 border border-emerald-400/40 text-[9px] font-extrabold px-2 py-0.5 rounded-full uppercase tracking-wider">
            About E-Learning Hub
          </span>
          <h1 className="text-sm sm:text-lg md:text-xl font-black leading-snug">Empowering Technical & Professional Skill Growth</h1>
          <p className="text-emerald-100/90 text-[11px] sm:text-xs leading-snug max-w-2xl mx-auto">
            We build industry-standard online learning programs designed to bridge the gap between academic education and real-world engineering & software expertise.
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2.5 sm:gap-3">
          <div className="bg-white p-3 sm:p-4 rounded-xl border border-gray-100 shadow-2xs text-center">
            <h3 className="text-lg sm:text-2xl font-black text-emerald-600">50,000+</h3>
            <p className="text-[10px] font-bold text-gray-500 uppercase mt-0.5">Active Students</p>
          </div>
          <div className="bg-white p-3 sm:p-4 rounded-xl border border-gray-100 shadow-2xs text-center">
            <h3 className="text-lg sm:text-2xl font-black text-emerald-600">120+</h3>
            <p className="text-[10px] font-bold text-gray-500 uppercase mt-0.5">Certified Courses</p>
          </div>
          <div className="bg-white p-3 sm:p-4 rounded-xl border border-gray-100 shadow-2xs text-center">
            <h3 className="text-lg sm:text-2xl font-black text-emerald-600">98%</h3>
            <p className="text-[10px] font-bold text-gray-500 uppercase mt-0.5">Satisfaction</p>
          </div>
          <div className="bg-white p-3 sm:p-4 rounded-xl border border-gray-100 shadow-2xs text-center">
            <h3 className="text-lg sm:text-2xl font-black text-emerald-600">15+</h3>
            <p className="text-[10px] font-bold text-gray-500 uppercase mt-0.5">Affiliations</p>
          </div>
        </div>

        {/* Mission & Vision */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4">
          <div className="bg-white p-3.5 sm:p-5 rounded-xl border border-gray-100 shadow-2xs space-y-2">
            <div className="w-8 h-8 rounded-lg bg-emerald-50 text-emerald-600 flex items-center justify-center font-bold">
              <Target size={18} />
            </div>
            <h2 className="text-xs sm:text-sm font-bold text-gray-900">Our Mission</h2>
            <p className="text-[11px] sm:text-xs text-gray-500 leading-normal">
              To provide affordable, high-quality, practical learning courses in Electrical Vehicles, IT, Mechanical, Civil, NDT, DT, and modern software development that empower students to build successful careers.
            </p>
          </div>

          <div className="bg-white p-3.5 sm:p-5 rounded-xl border border-gray-100 shadow-2xs space-y-2">
            <div className="w-8 h-8 rounded-lg bg-blue-50 text-blue-600 flex items-center justify-center font-bold">
              <Award size={18} />
            </div>
            <h2 className="text-xs sm:text-sm font-bold text-gray-900">Our Vision</h2>
            <p className="text-[11px] sm:text-xs text-gray-500 leading-normal">
              To be the premier online learning destination recognized globally for practical engineering mastery, verified certification, and career transformation.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default AboutUs;
